import { Link } from 'react-router-dom';
import { PrivacyContent } from './PrivacyContent';
import Footer from './Footer';
import { ReactComponent as Logo } from '../censuszen-logo.svg';
import '../styles/LegalPage.css';

export const PrivacyPolicy = () => (
    <div className="legal-page">
        <nav className="legal-nav">
            <Link to="/">
                <Logo className="legal-nav-logo" aria-label="CensusZen" />
            </Link>
            <div className="legal-nav-links">
                <Link to="/login" className="legal-nav-link legal-nav-link--ghost">
                    Log in
                </Link>
                <Link to="/register" className="legal-nav-link legal-nav-link--solid">
                    Sign Up
                </Link>
            </div>
        </nav>

        <main className="legal-body">
            <div className="legal-card">
                <PrivacyContent />
            </div>
            <div className="legal-back">
                <svg className="legal-back-arrow" width="14" height="14" viewBox="0 0 16 16" fill="none">
                    <path d="M10 12L6 8L10 4" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
                <Link to="/">Back to home</Link>
            </div>
        </main>

        <Footer variant="legal" />
    </div>
);
